import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from "react-redux";
import { createStore } from "redux";
import reducer from "./reducers";
import * as actions from "./actions";
import AppContainer from './AppContainer';
import {unregister} from './registerServiceWorker';
import { gsntvIframeCommunicationInit } from "./utils/gsntv";
import { BrowserRouter as Router, Route, Switch} from 'react-router-dom';



//==============================================

window.config = null;
window.questions = null; // initial list, used to reset pool
window.bonusQuestions = null; // initial list, used to reset pool
window.alternateWords = null;


window.questionsPool = null; // randomize questions from this list
window.bonusQuestionsPool = null; // randomize questions from this list


// ---- sounds ------
window.sounds = {};

window.sounds.introBg = new window.Howl({
  src: ['media/GM-AP_America_Building_r1_FULL.mp3'],
  volume: 1
});

window.sounds.roundBg = new window.Howl({
  src: ['media/America_Building_Full_mixdown.mp3'],
  volume: 1,
  loop: true
});

window.sounds.bonusBg = new window.Howl({
  src: ['media/America_Building_R2_Full_mixdown.mp3'],
  volume: 1,
  loop: true
});

window.sounds.gameOverBg = new window.Howl({
  src: ['media/GM_America_Says_Theme_2_END_CREDITS_14SEC.mp3'],
  volume: 1
});

window.sounds.correct = new window.Howl({
  src: ['media/Correct_Answer_2.mp3'],
  volume: 1
});

window.sounds.wrong = new window.Howl({
  src: ['media/Wrong_Answer_1_ALT_2.mp3'],
  volume: 1
});

window.sounds.reveal = new window.Howl({
  src: ['media/91926__tim-kahn__ding.mp3'],
  volume: 1
});

window.sounds.buttonHover = new window.Howl({
  src: ['media/little_robot_sound_factory_multimedia_Click_Electronic_05.mp3'],
  volume: 1
});

window.sounds.buttonClick = new window.Howl({
  src: ['media/multimedia_rollover_078.mp3'],
  volume: 1
});

window.sounds.startButtonClick = new window.Howl({
  src: ['media/btn_click.mp3'],
  volume: 1
});

window.sounds.timerRunningOut = new window.Howl({
  src: ['media/multimedia_rollover_077.mp3'],
  volume: 1
});

window.sounds.buzzer = new window.Howl({
  src: ['media/times_up_5.mp3'],
  volume: 1,
  sprite: {
  	buzzer: [0, 2000]
  }
});



// ---- toggle sounds when leaving / re-entering site

window.$(window).bind("blur", function(){
	window.Howler.volume(0);
});

window.$(window).bind("focus", function(){
	window.Howler.volume(1);
});

//window.Howler.volume(.1);

//==============================================




const store = createStore(
  reducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

gsntvIframeCommunicationInit(store, actions);


ReactDOM.render(
  <Provider store={store}>
    <Router>
      <Switch>
				<Route 
					path="/:affiliate" 
					render={ ({match, props}) => (
            <AppContainer {...props} match={match} />
					)}
				/>
				<Route
						path="/"
						render={ props => (
              <AppContainer {...props} />
						)}
				/>
			</Switch>
    </Router>
  </Provider>,
  document.getElementById('root')
);

unregister();






// WEBPACK FOOTER //
// ./src/js/index.js